import globalEventEmitter from '@/modules/EventEmitter';
import { EVENTS } from '@/modules/EventEmitter/const';
import { useUserStore } from '@/stores/user';
import {
  armInitialGenerationProject,
  getInitialGenerationNotificationOwnerId,
  getSystemNotificationPreference,
} from './helper';

/**
 * 用户确认视觉方向后，显式记录本次首版生成任务。
 * 完成通知只消费这里记录过的项目，避免依赖完成瞬间已经变化的项目状态。
 */
export function beginInitialWebsiteGenerationSystemNotification(projectId: string) {
  const userId = useUserStore.getState().userInfo?.userId;
  if (userId && getSystemNotificationPreference(userId) === false) {
    return;
  }

  const ownerId = getInitialGenerationNotificationOwnerId(projectId, userId);
  armInitialGenerationProject(projectId, ownerId);
  globalEventEmitter.emit(EVENTS.INITIAL_WEBSITE_GENERATION_NOTIFICATION_ARMED, { projectId });
}
